<template>
    <v-card height="110px" class="elevation-4">
        <v-col>
            <img v-if="productLogo" :src="getProductLogoImageUrl()" class="logoStyle pr-5" alt="logo"/>
        </v-col>
    </v-card>
</template>

<script>
    import {preLoginService} from "../services"

    export default {
        name: 'Header',
        data() {
            return {
                productLogo: ''
            }
        },
        methods: {
            logoData: function () {
                preLoginService.getLogoData().then(response => {
                    this.productLogo = response.dataResponse.productLogo
                }).catch(error => {
                    console.log(error)
                })
            },
            getProductLogoImageUrl: function() {
                return process.env.VUE_APP_BACKEND_URL + '/api/media/logo/' + this.productLogo
            }
        },
        created() {
            this.logoData()
        }
    }
</script>

<style>
.logoStyle {
    max-height: 65px;
}
</style>
